/**
 * @file dockGlass.ts
 * @brief THE glass of every web dock, the twin of the phone's
 *        FRONTEND/src/shared/theme/dockGlass.ts. The numbers are CSS
 *        variables in src/index.css (--dock-glass-*, --dock-fade).
 *
 * @details
 * DES 04-10-2026: "phone jaisa kar ke dikhao". The web docks were nearly
 * solid (75% fill, 24px blur, a fade that went fully solid under them). Now
 * they read like the phone's: a 12% tint, a light 6px blur, and a fade
 * behind that never goes solid (max 55%), so the page shows through.
 *
 * Used by: Notes (write button, note action dock), Meeting detail's section
 * dock, ExpandingSearch, PageDock (fade + dark DockActionButton), Home's
 * dock fade, SwipeButton's dark track, the Boardrooms "+", Session detail's
 * dock, Note compose's Save, and "Play this moment" (08-10-2026).
 * dockSelected: the meeting section dock's tab and Session detail's
 * Transcript PDF pill (U3, 03-11-2026).
 *
 * @author DES
 * @date 04-10-2026
 * @updated 08-10-2026 — values moved to CSS variables in index.css; dark
 *   glass = blur 12 + 5% white, no edge; dockGlassDark + dockFadeBehind.
 */

/**
 * The pill face: `.dock-glass` in index.css = phone `dockTint` +
 * `dockBlurAmount` (light 12% white / 6px; dark 5% white / 12px since
 * 08-10-2026). The numbers live in index.css (--dock-glass-blur,
 * --dock-glass-tint); dark has no edge and no shadow, as the phone.
 */
export const dockGlass =
  "dock-glass rounded-full border border-border/70 shadow-[0_8px_30px_rgba(0,0,0,0.12)] dark:border-transparent dark:shadow-none";

/**
 * Dark-only glass over a control's own light look (red slide track, red dock
 * pills, the Boardrooms "+"): `.dock-glass-dark` in index.css. Pair it with
 * `dark:text-app-text` (label) and a brand glyph (DES 08-10-2026).
 */
export const dockGlassDark = "dock-glass-dark";

/**
 * THE selected pill on a dock: `.dock-selected` in index.css = phone
 * `dockSelectedPillStyle` (U3, option D, DES 03-11-2026). Light: brand at
 * 10% + brand label; dark: --dock-selected-dark (brand at 72%) + a faint
 * top highlight, white label. Every dock's selected pill uses this, so
 * they can't drift.
 */
export const dockSelected = "dock-selected";

/** The fade behind a dock: phone `dockFadeColors`, 0 → 25% → 55%, never solid. */
export const dockFade = "dock-fade";

/**
 * The same fade as a layer behind a sticky dock row (`::before`, down to the
 * viewport bottom under its bottom-6 gap). The row must be positioned
 * (sticky is) with a z-index, so the layer stays behind its controls.
 */
export const dockFadeBehind = "dock-fade-behind";
